import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value
    if (!password) return null

    const strongRegex = /(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-zA-Z]).{8,}/
    const mediumRegex = /(?=.*[0-9])(?=.*[a-zA-Z]).{8,}/
    const weakRegex = /.{6,}/

    if (strongRegex.test(password)) {
      return null // ✅ Strong = valid
    } else if (mediumRegex.test(password)) {
      return { weakPassword: true } // ❌ Medium or weak = invalid
    } else if (weakRegex.test(password)) {
      return { weakPassword: true }
    } else {
      return { poorPassword: true } // ❌ Very poor
    }
  }
}
